// ─────────────────────────────────────────────────────────────────────────────
// EyeToggle — the show/hide-password eye button used inside password fields.
// Extracted so the (verbose) inline SVGs live in one place. `shown` picks the
// eye-off vs eye icon; `onToggle` flips the parent's visibility state.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../Auth.module.css";

export function EyeToggle({ shown, onToggle }) {
  return (
    <button type="button" className={styles.loginEyeBtn} onClick={onToggle} aria-label={shown ? "Hide password" : "Show password"}>
      {shown ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" /><path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
      )}
    </button>
  );
}

export default EyeToggle;
